// Third party packages
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ApiService } from "src/app/shared/services/api.service";
import { HelperService } from "src/app/shared/services/helper.service";
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var CondoStructuresService = /** @class */ (function () {
    function CondoStructuresService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
        /**
         * Class constructor
         */
        this.remakeStrucutureDocs = {};
    }
    /**
     * Set docs of remake structure
     *
     * @since 1.0.0
     *
     * @returns void
     */
    CondoStructuresService.prototype.setRemakeStrucutureDocs = function (activeSection, docId, subDoc) {
        this.remakeStrucutureDocs = {
            activeSection: activeSection,
            docId: docId,
            subDoc: subDoc,
        };
    };
    /**
     * Get docs of remake structure
     *
     * @since 1.0.0
     *
     * @returns void
     */
    CondoStructuresService.prototype.getRemakeStrucutureDocs = function () {
        return this.remakeStrucutureDocs;
    };
    /**
     * Set the documents of a remake on the 3.0.0 archive (MAP-A1): the element being remade and the
     * ticked rows of the new archive, by id.
     *
     * Same slot as @see setRemakeStrucutureDocs, so what reads it does not change: the mapping tab
     * matches `activeSection` against the section of the new element and sends the whole object as
     * `remakePlantDocs` on the POST that creates it, where the back-end reads `sourceStructureId` and
     * `documentArchiveDocIds` (and ignores `activeSection`). Without `docId` and `subDoc` the legacy
     * copy does not run: the rows go to the new archive only.
     *
     * @since 3.0.0
     *
     * @param activeSection Section of the element being remade, where the new one is created
     * @param selection     The element being remade and the ticked rows
     */
    CondoStructuresService.prototype.setRemakePlantSelection = function (activeSection, selection) {
        this.remakeStrucutureDocs = {
            activeSection: activeSection,
            sourceStructureId: selection.sourceStructureId,
            documentArchiveDocIds: selection.documentArchiveDocIds,
        };
    };
    /**
     * Create a new condo structure
     *
     * @since 1.0.0
     *
     * @param condoStructure condoStructure data
     * @returns Observable<any>
     */
    CondoStructuresService.prototype.create = function (propertyId) {
        var data = {
            property: propertyId,
        };
        return this.apiService.apiCall("POST", "condo-structures", data, undefined, undefined, undefined, "v2");
    };
    /**
     * Get condo structures list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    CondoStructuresService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "condo-structures", params, undefined, undefined, undefined, "v2");
    };
    /**
     * Get a list of all available structures (connection) in given condoStructureId
     *
     * @since 1.0.0
     */
    CondoStructuresService.prototype.getCondoStructuresListForSelect = function (condoStructureId) {
        return this.apiService.apiCall("GET", "condo-structures/" + condoStructureId + "/connections", {}, undefined, undefined, undefined, "v2");
    };
    /**
     * Get a list of all available electric meters (connection) in given condoStructureId
     *
     * @since 1.0.0
     */
    CondoStructuresService.prototype.getCondoStructuresListForElectricMeter = function (condoStructureId) {
        return this.apiService.apiCall("GET", "condo-structures/" + condoStructureId + "/electric-meter", {}, undefined, undefined, undefined, "v2");
    };
    /**
     * Get a list of all available water meters (connection) in given condoStructureId
     *
     * @since 1.0.0
     */
    CondoStructuresService.prototype.getCondoStructuresListForWaterMeter = function (condoStructureId) {
        return this.apiService.apiCall("GET", "condo-structures/" + condoStructureId + "/water-meter", {}, undefined, undefined, undefined, "v2");
    };
    /**
     * Get a list of all available gas meters (connection) in given condoStructureId
     *
     * @since 1.0.0
     */
    CondoStructuresService.prototype.getCondoStructuresListForGasMeter = function (condoStructureId) {
        return this.apiService.apiCall("GET", "condo-structures/" + condoStructureId + "/gas-meter", {}, undefined, undefined, undefined, "v2");
    };
    /**
     * Get a list of all available Caretakers and Cleaning Companies in given condoStructureId
     *
     * @since 1.0.0
     */
    CondoStructuresService.prototype.getCondoStructuresCaretakers = function (condoStructureId) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "condo-structures/" + condoStructureId + "/caretakers", {}, undefined, undefined, undefined, "v2")
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all properties
     *
     * @since 1.0.0
     */
    CondoStructuresService.prototype.getExport = function () {
        var _this = this;
        return this.apiService
            .apiCall("GET", "condo-structures/export", {}, { responseType: "blob" }, undefined, undefined, "v2")
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get given condo structure with condoStructure ID
     *
     * @since 1.0.0
     *
     * @param condoStructureId ID of the condoStructure to get
     */
    CondoStructuresService.prototype.get = function (condoStructureId) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "condo-structures/" + condoStructureId, undefined, undefined, undefined, undefined, "v2")
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get given condo structure with condoStructure ID
     *
     * @since 1.0.0
     *
     * @param condoStructureId ID of the condoStructure to get
     */
    CondoStructuresService.prototype.getView = function (condoStructureId) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "condo-structures/" + condoStructureId + "/view", undefined, undefined, undefined, undefined, "v2")
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get given condo structure with condoStructure ID per QRcode area
     *
     * @since 1.0.0
     *
     * @param condoStructureId ID of the condoStructure to get
     */
    CondoStructuresService.prototype.getQrcode = function (condoStructureId) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "condo-structures/qrcode/" + condoStructureId, undefined, undefined, undefined, undefined, "v2")
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update condo structure with given condoStructureId with given data
     *
     * @since 1.0.0
     *
     * @param condoStructureId ID of condo structure to update
     * @param data New condo structure's data
     */
    CondoStructuresService.prototype.update = function (condoStructureId, data) {
        return this.apiService.apiCall("PATCH", "condo-structures/" + condoStructureId, data, undefined, undefined, undefined, "v2");
    };
    /**
     * Delete permanently a condo structure
     *
     * @since 1.0.0
     *
     * @param condoStructureId ID of the condo structure
     */
    CondoStructuresService.prototype.delete = function (condoStructureId) {
        return this.apiService.apiCall("DELETE", "condo-structures/" + condoStructureId, undefined, undefined, undefined, undefined, "v2");
    };
    /**
     * Update condo structure section
     *
     * @since 1.0.0
     *
     * @param endpoint Section raw endpoint
     * @param condoStructureId ID of condo structure to update
     * @param sectionId ID of condo structure section to update
     * @param data New condo structure's data
     */
    CondoStructuresService.prototype.updateSection = function (endpoint, condoStructureId, sectionId, data, mappaturaOpen) {
        var endpoint2 = endpoint.replace(":structureId", condoStructureId);
        if (endpoint === "condo-structures/:structureId/anagrafica") {
            var endpoint3 = endpoint2.replace("/anagrafica", "");
            return this.apiService.apiCall("PATCH", "" + endpoint3, { open: mappaturaOpen, anagrafica: data }, undefined, undefined, undefined, "v2");
        }
        return this.apiService.apiCall("PUT", endpoint2 + "/" + sectionId, data, undefined, undefined, undefined, "v2");
    };
    /**
     * Create condo structure section item
     *
     * @since 1.0.0
     *
     * @param endpoint Section raw endpoint
     * @param condoStructureId ID of condo structure where to create section item
     * @param data New condo structure item's data
     */
    CondoStructuresService.prototype.createSectionItem = function (endpoint, condoStructureId, data) {
        var endpoint2 = endpoint.replace(":structureId", condoStructureId);
        return this.apiService.apiCall("POST", endpoint2, data, undefined, undefined, undefined, "v2");
    };
    /**
     * Update condo structure section
     *
     * @since 1.0.0
     *
     * @param endpoint Section raw endpoint
     * @param condoStructureId ID of condo structure to update
     * @param sectionId ID of condo structure section to update
     * @param data New condo structure's data
     */
    CondoStructuresService.prototype.deleteSection = function (endpoint, condoStructureId, sectionId) {
        var endpoint2 = endpoint.replace(":structureId", condoStructureId);
        return this.apiService.apiCall("DELETE", endpoint2 + "/" + sectionId, undefined, undefined, undefined, undefined, "v2");
    };
    /**
     * Update condo structure section
     *
     * @since 1.0.0
     *
     * @param text Note text
     * @param condoStructureId ID of condo structure to update
     * @param structureName Name of condo structure section
     * @param structureId ID of condo structure section to update
     * @param noteId New condo structure's note to delete
     */
    CondoStructuresService.prototype.updateNote = function (data, condoStructureId, structureName, structureId, noteId) {
        var structureNameEncoded = encodeURIComponent(structureName);
        return this.apiService.apiCall("PUT", "condo-structures/" + condoStructureId + "/note/" + structureNameEncoded + "/" + structureId + "/" + noteId + "/", data, undefined, undefined, undefined, "v2");
    };
    /**
     * Update condo structure section
     *
     * @since 1.0.0
     *
     * @param condoStructureId ID of condo structure to update
     * @param structureName Name of condo structure section
     * @param structureId ID of condo structure section to update
     * @param noteId New condo structure's note to delete
     */
    CondoStructuresService.prototype.deleteNote = function (condoStructureId, structureName, structureId, noteId) {
        return this.apiService.apiCall("DELETE", "condo-structures/" + condoStructureId + "/note/" + structureId + "/" + noteId + "/", undefined, undefined, undefined, undefined, "v2");
    };
    CondoStructuresService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CondoStructuresService_Factory() { return new CondoStructuresService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: CondoStructuresService, providedIn: "root" });
    return CondoStructuresService;
}());
export { CondoStructuresService };
